import { PageLayout } from '@@viewCommonComponents/forms/Layouts';
import { FormProvider, useFieldArray } from 'react-hook-form';
import { Icon, PageTitle, Tabs } from '@fasstech/middle-design-system';
import TabsPagination from '@@viewCommonComponents/TabsPagination.jsx';
import { useTabs } from '@@viewCommonComponents/hooks/useTabs.js';
import CustomerForm from './components/CustomerForm.jsx';
import GranteesForm from './components/GranteesForm.jsx';
import { any, not, prop } from 'ramda';
import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer.jsx';
import useSimulationPavillonInformationForm from './hooks/useSimulationPavillonInformationForm.js';
import ExtraUnauthorizedModal from '@@viewCommonComponents/displayer/ExtraUnauthorizedModal.jsx';

const SimulationPavillonInformationForm = ({
  getInformations: project,
  phoneIndicatives,
  regimeObligatoire,
  professionalSituations,
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber
}) => {
  const {
    $onPrevClick,
    onSubmit,
    form,
    unauthorizedModalMessage,
    setUnauthorizedModalMessage,
    isUnauthorized
  } = useSimulationPavillonInformationForm({ project });

  const { watch, control } = form;
  const { isValid } = form.formState;

  const { fields } = useFieldArray({
    control,
    name: 'grantees',
    keyName: 'uuid'
  });

  const customer = watch('customer');

  const grantees = getMiddleBoolean('BENEFICIAIRE_DONNEES_CONTRAT_EST_NECESSAIRE')
    ? [customer, ...fields]
    : [customer];

  const { tabs, setTabs, updateVisibility, isButtonDisabled, displayTabsPagination } = useTabs({
    grantees,
    getMiddleText,
    filteredViewMode: !getMiddleBoolean('BENEFICIAIRE_DONNEES_CONTRAT_EST_NECESSAIRE')
  });

  const hasUnrequiredFields = (form) => {
    // Check if the customer has at least one email or phone number when these fields are not required
    const hasCustomerEmails = any(prop('value'), form.watch('customer.emails') || []);
    const hasCustomerPhones = any(prop('number'), form.watch('customer.phones') || []);
    return hasCustomerEmails || hasCustomerPhones;
  };

  return (
    <FormProvider {...form}>
      <form className={'w-full'} onSubmit={form.handleSubmit(onSubmit)}>
        <PageLayout>
          <Icon name={'informations_adherent'} size={70} />
          <PageTitle>{tabs.selectedTab === 0 ? 'Coordonnées' : 'Bénéficiaire'}</PageTitle>

          <div className={'flex flex-col gap-4'}>
            <TabsPagination
              updateVisibility={updateVisibility}
              isButtonDisabled={isButtonDisabled}
              show={displayTabsPagination}
            >
              <Tabs
                items={tabs.tabs}
                selected={tabs.selectedTab}
                onClick={(index) =>
                  setTabs({
                    selectedTab: index,
                    tabs: tabs.tabs
                  })
                }
                isDisplayed={tabs.tabs.length > 1}
              />
            </TabsPagination>
          </div>

          <CustomerForm
            selectedTab={tabs.selectedTab}
            getMiddleText={getMiddleText}
            getMiddleBoolean={getMiddleBoolean}
            phoneIndicatives={phoneIndicatives}
          />

          <GranteesForm
            selectedTab={tabs.selectedTab}
            fields={fields}
            getMiddleText={getMiddleText}
            getMiddleBoolean={getMiddleBoolean}
            getMiddleNumber={getMiddleNumber}
            regimeObligatoire={regimeObligatoire}
            professionalSituations={professionalSituations}
          />
        </PageLayout>
        <ButtonContainer
          $onPreviousButtonClick={$onPrevClick}
          nextButtonLabel={getMiddleText('GENERAL_COMMON_TEXTS_NEXT_BUTTON_LABEL')}
          nextButtonIsDisabled={not(isValid) || !hasUnrequiredFields(form) || isUnauthorized}
          isFormError={not(isValid)}
          getMiddleText={getMiddleText}
        />
      </form>
      <ExtraUnauthorizedModal
        isDisplayed={unauthorizedModalMessage}
        unauthorizedModalMessage={unauthorizedModalMessage}
        setUnauthorizedModalMessage={setUnauthorizedModalMessage}
      />
    </FormProvider>
  );
};

export default SimulationPavillonInformationForm;
